import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=cabef066&"
import script from "./RefundPolicy.vue?vue&type=script&lang=js&"
export * from "./RefundPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports